import React from "react";
import { css, useTheme } from "@emotion/react";
import useFontSize from "core/hooks/useFontSize";

type Props = {
    children: React.ReactNode,
};

const Header: React.FC<Props> = ({
    children,
}) => {
    const theme = useTheme();
    const Tag = "h1";
    const [fontSize, lineHeight] = useFontSize(Tag, '2');

    const style = css`
        font-weight: ${theme.fonts.weights.bold};
        color: ${theme.colours.curiousBlue};
        white-space: break-spaces;
        font-size: ${fontSize}px;
        line-height: ${lineHeight}px;
    `;

    return (
        <Tag css={style}>{children}</Tag>
    );
};

export default Header;
